/* *******************************************************
    SERVICIO DE FUNCIONES AUXILIARES Y OTROS EXPORTS
******************************************************* */

import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  constructor(
    private _t: TranslateService
  ) {}


  /* ********** VALIDAR CONTRASEÑAS ********** */

  static validatePassword(control: AbstractControl) {
    const pass = control.value;
    if (!containsNumber(pass) || !containsLetter(pass)) {
      return { invalid_password: true };
    }
    return null;
  }


  /* ********** MATCH DE CONTRASEÑAS E EMAILS ********** */

  static matchPasswords(control: AbstractControl) {
    const password = control.get('newPass')!.value;
    const confirmPassword = control.get('confirmPass')!.value;
    if (password === confirmPassword) {
      return null;
    }
    return { match_password: true };
  }

  static matchUser(control: AbstractControl) {
    const user = control.get('user')!.value;
    const confirmUser = control.get('confirmUser')!.value;
    if (user === confirmUser) {
      return null;
    }
    return { match_user: true };
  }


  /* ********** FECHAS ********** */

  // Obtener fecha de hoy
  static getCurrentDate() {
    const d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('-');
  }


  /* ********** NUMBERS ********** */

  getOrdinalNumber(edition: number): string {

    let n = edition;
    if (n > 10) {
      // Si tiene dos dígitos, tomamos el último solamente
      const l = edition.toString();
      n = parseInt(l.split('')[l.toString().length-1]);
    }

    if (this._t.currentLang == 'en-us') {
      switch(n) {
        case 1 : { return 'st'; }
        case 2 : { return 'nd'; }
        case 3 : { return 'rd'; }
        case 4 : case 5 : case 6 : case 7 : case 8 : case 9 : case 10 : case 0 : { return 'th'; }
        default : { return ''; }
      }
    } else {
      return 'a';
    }

  }

  getFormatNumber(n: number | null): string {
    // https://developer.mozilla.org/es/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
    const lang = this._t.currentLang;
    return n ? new Intl.NumberFormat(lang ? lang : 'es-ar', {}).format(n) : '####';
  }

  currencyFormat(price: string | null): string {
    if (!price)
      return '';
    if (this._t.currentLang == 'en-us')
      return price;
    else
      return price.replace(/,/, '.');
  }

  /* ********** OTROS ********** */

  generateRandomString(num: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let str = '';
    const charactersLength = characters.length;
    for (let i = 0; i < num; i++) {
      str += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return str;
  }

}


/* ********** FUNCIONES AUX PARA VALIDAR CONTRASEÑAS ********** */

// Función para saber si un texto contiene una letra
function containsLetter(texto: string){
  const letters = 'abcdefghijklmnopqrstuvwxyz';
  texto = texto.toLowerCase();
  for (let i = 0; i < texto.length; i++) {
    if (letters.indexOf(texto.charAt(i), 0) !== -1){
      return true;
    }
  }
  return false;
}

// Función para saber si un texto contiene un número
function containsNumber(pass: string) {
  const numbers = '0123456789';
  for (let i = 0; i < pass.length; i++){
    if (numbers.indexOf(pass.charAt(i), 0) !== -1){
      return true;
    }
  }
  return false;
}
